import { atom } from "recoil";

export const showPaused = atom({
  key: "showPaused",
  default: {
    value: false,
  },
});
